// The player's Gruvetto score (ADR 0009), read from the server: the only one that counts for sign-ups and online
// rooms. The last known value is kept for display while the server is unreachable.
import { powerScore } from '@gruvetto/core';
import type { RatingResponse } from '@gruvetto/contracts';
import { state, update } from './store.js';
import { api, isLoggedIn, ApiError } from './api.js';

/** Power score of the declared FTP and mass: the score never falls under it, even before the next refresh. */
const declared = (): number => powerScore(state.profile.ftp / state.profile.mass, state.profile.mass);

/** Current score, synchronous for rendering: the last known rating, never under the declared FTP. */
export function myScore(): number {
  const known = (state.rating as RatingResponse | null)?.score ?? 0;
  return Math.round(Math.max(known, declared()) * 10) / 10;
}

/** Refreshes the stored rating from the server (kept as is when offline). */
export async function refreshRating(): Promise<void> {
  if (!isLoggedIn()) return;
  try {
    const r = await api<RatingResponse>('/rating');
    update(s => { s.rating = r; });
  } catch (e) {
    if (!(e instanceof ApiError && e.offline)) throw e;
  }
}

/** Same, for the places where a failed refresh must not interrupt anything (end of a ride, start-up). */
export const refreshRatingQuietly = (): void => { refreshRating().catch(() => {}); };
